import Vue from 'vue'

function add(state, obj) {
	if (! state.data[obj.type])
		Vue.set(state.data, obj.type, {})
	Vue.set(state.data[obj.type], obj.id, obj)
}

export default {
	namespaced: true,
    state: {
		data: {},
		profile: {},
		loading: {}
	},
    actions: {
		getProfile({ state }, query) {

		},
		getType({ state }, query) {

		},
		loadContent({ state, dispatch, commit, rootState }, query) {
			if (! query.type || state.loading[query.type])
				return

			commit('startLoadingType', query.type)

			return dispatch('get', {
				url: '/provider/' + rootState.provider.id + '/content/' + query.type,
				query
			}, { root: true })
			.then((response) => {
				commit('finishLoadingType', query.type)
				if (response.content)
					commit('cache', response.content)
			})
			.catch((error) => {
				commit('finishLoadingType', query.type)
				throw error
			})
		}
	},
	getters: {
		getContent(state) {
			return (type, id) => {
				if (state.data[type]) {
					if (Array.isArray(id))
						return id.map((i) => {
							if(typeof i === 'object' && i.id)
								return state.data[type][i.id]
							else
								return state.data[type][i]
						})
					if(typeof id === 'object' && id.id)
						return state.data[type][id.id]
					else
						return state.data[type][id]
				}
			}
		},
		getContentKey(state) {
			return (type, id, key) => {
				if (state.data[type] && state.data[type][id])
					return state.data[type][id][key]
			}
		},
		getContentType(state) {
			return (type) => state.data[type]
		},
		getProfileContent(state) {
			return (profile, type) => {
				let content = state.data.profile[profile]
				return (content && type) ? content[type] : (content || [])
			}

		}
	},
	mutations: {
		startLoadingType(state, type) {
			Vue.set(state.loading, type, true)
		},
		finishLoadingType(state, type) {
			Vue.delete(state.loading, type)
		},
		cache(state, content) {
			Object.keys(content).forEach((type) => {
				if (! state.data[type])
					Vue.set(state.data, type, {})
				Object.keys(content[type]).forEach((id) => {
					
					// Profile can have nested types
					if (type === 'profile') {
						try {
							const combProfile = {
								...(state.data[type][id] ? state.data[type][id] : {}),
								...content[type][id]
							}
							Vue.set(state.data[type], id, combProfile)
						} catch (error) {
							console.error('Got error in combining profiles ', error)
							Vue.set(state.data[type], id, content[type][id])
						}
						
						Object.keys(content[type][id]).forEach((k) => {
							let value = content[type][id][k]
							if (Array.isArray(value))
								content[type][id][k] = value.map((v) => {
									if (typeof v === 'object') {
										if (! state.data[v.type])
											Vue.set(state.data, v.type, {})
										Vue.set(state.data[v.type], v.id, v)
										return v.id
									}
									return v
								})
						})
					}
					else
						Vue.set(state.data[type], id, content[type][id])
				})
			})
		},
		addProfile(state, profile) {
			state.profile[profile.id] = profile
			Object.keys(profile).forEach((k) => {
				if (Array.isArray(profile[k]))
					profile[k].forEach((obj) => add(state, obj))
			})
		},
		addContent(state, content) {
			if (Array.isArray(content))
				content.forEach((c) => add(state, c))
			else
				add(state, c)
		}
	}
}
